export enum ConcluidoNaoConcluidoEnum {
    Concluido = 'CONCLUIDO',
    NaoConcluido = 'NAO_CONCLUIDO',
}
